import React from 'react';
import {motion} from 'framer-motion';

const AboutEbook=({openCheckoutPopup})=> {
  const sections=[
    {
      title: "Lead Magnets & Offers",
      points: [
        "Create irresistible lead magnets",
        "Design high-converting offers",
        "Build landing pages that sell"
      ]
    },
    {
      title: "WhatsApp & Email Automations",
      points: [
        "Set up automated sequences",
        "Create engaging broadcasts",
        "Build nurture campaigns"
      ]
    },
    {
      title: "Conversion Boosters",
      points: [
        "Optimize your sales funnel",
        "Increase conversion rates",
        "Reduce cart abandonment"
      ]
    },
    {
      title: "Pricing & Festive Bundles",
      points: [
        "Strategic pricing models",
        "Create irresistible bundles",
        "Festive season strategies"
      ]
    },
    {
      title: "Follow-Up Systems",
      points: [
        "Never miss a prospect",
        "Automated reminders",
        "Multi-channel follow-ups"
      ]
    },
    {
      title: "Customer Retention Hacks",
      points: [
        "Keep customers coming back",
        "Build loyalty programs",
        "Increase lifetime value"
      ]
    },
    {
      title: "Upsell & Referral Strategies",
      points: [
        "Maximize order value",
        "Create referral systems",
        "Cross-sell effectively"
      ]
    },
    {
      title: "Content That Converts",
      points: [
        "Write compelling copy",
        "Create viral content",
        "Engage your audience"
      ]
    },
    {
      title: "CRM & AI Tools",
      points: [
        "Organize your prospects",
        "Automate with AI",
        "Track performance"
      ]
    },
    {
      title: "Diwali Campaign Templates",
      points: [
        "Ready-to-use campaigns",
        "Festive messaging",
        "Seasonal promotions"
      ]
    }
  ];

  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Your Step-by-Step <span className="gradient-text">Playbook to Double Your Sales</span>
            Fast 📘
          </h2>
          <p className="text-lg text-gray-600">
            24 comprehensive sections with proven strategies
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {sections.map((section, index)=> (
            <motion.div
              key={index}
              className="bg-gradient-to-br from-purple-50 to-orange-50 p-6 rounded-2xl shadow-lg card-hover border border-purple-100"
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.05}}
              viewport={{once: true}}
            >
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-gradient-to-br from-purple-600 to-orange-400 rounded-lg flex items-center justify-center text-white font-bold mr-3">
                  {index + 1}
                </div>
                <h3 className="font-bold text-lg text-gray-800">{section.title}</h3>
              </div>
              <ul className="space-y-2">
                {section.points.map((point, pointIndex)=> (
                  <li key={pointIndex} className="flex items-center text-gray-600">
                    <span className="text-green-500 mr-2">✓</span>
                    {point}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.8}}
          viewport={{once: true}}
        >
          <button 
            onClick={openCheckoutPopup}
            className="glow-button text-white px-8 py-4 rounded-xl font-bold text-lg"
          >
            Unlock All 24 Ways for ₹97 →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutEbook;